import { Component, OnInit, Input, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TenantEntryDialogService } from './TenantEntryDialogService';
import { AbstractComponent } from '../../../../../../../core/common/component/AbstractComponent';

@Component({
  selector: 'tenant-entry-dialog',
  templateUrl: './TenantEntryDialog.html',
  styleUrls: ['./TenantEntryDialog.scss'],
})
export class TenantEntryDialogComponent extends AbstractComponent {

  params;
  tenantCd;
  registerForm: FormGroup;
  thumbnailSrc;
  iconFile;
  selectedAdminFlg;


  scope = {
    message : '',
    isEdit : false
  }
  @ViewChild('contentBody',  { static: true }) 
  public contentBody: ElementRef;


  constructor(
     @Inject(MAT_DIALOG_DATA) public parameter: any,
              private matDialogRef : MatDialogRef<TenantEntryDialogComponent>,
              private service : TenantEntryDialogService,
              private formBuilder: FormBuilder,
    ) {
    super();
    this.params = parameter;
    // this.toasterService = toasterService;
  }
  public componentWillMount() {

    this.registerForm = this.formBuilder.group({
      tenantCd: new FormControl({value: '', disabled: true}, Validators.required),
      tenantName: new FormControl('', Validators.required),
      tel: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      mainFamilyName: new FormControl('', Validators.required),
      mainFirstName: new FormControl('', Validators.required),
      mainPosition: new FormControl(''),
      mainEmail: new FormControl('', [Validators.required ,Validators.email]),
      adminFlg: new FormControl(''),      
    });
    if (this.params.tenant) {
      this.tenantCd = this.params.tenant.tenantCd;
      this.scope.isEdit = true;
      for (let key of Object.keys(this.params.tenant)) {
        if (this.registerForm.controls[key]) {
          this.registerForm.controls[key].setValue(this.params.tenant[key]);
        }
      }
    } else {
      this.registerForm.addControl('password', new FormControl('', Validators.required));
      this.service.getUuid().subscribe((res) => {
        this.registerForm.controls.tenantCd.setValue(res[0]);
        this.tenantCd = res[0];
        this.service.generatePW().subscribe((pass) => {
          this.registerForm.controls.password.setValue(pass[0]);
        });
      },(err) => {
        console.log(err);
      });
    }
  }

  public onSubmit() {
    if (this.registerForm.invalid) {
      return;
    }
    this.registerForm.controls.adminFlg.setValue(0);
    const parameter = Object.assign({
      tenantCd : this.tenantCd
    }, this.registerForm.value);

    if (!this.scope.isEdit) {
      this.service.create(parameter).subscribe(
        () => this.matDialogRef.close('SUCCESS'),
        (err) => {
          this.contentBody.nativeElement.scrollTop = 0;
          this.scope.message = err;
        }
      );
    } else {
      this.service.update(parameter).subscribe(
        () => this.matDialogRef.close('SUCCESS'),
        (err) => {
          this.contentBody.nativeElement.scrollTop = 0;
          this.scope.message = err;
        }
      );
    }
  }

  /** icon セットアップ */
  public uploadSelect(e) {
    if (e.target.files && e.target.files[0]) {
      this.iconFile = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event:any) => {
        this.thumbnailSrc = event.target.result;
      }
    }
  }

  public get f() {
    return this.registerForm;
  }


}
